/**
 * THIS UTILITY FUNCTION SHOULD BE MOVED TO CHECKOUT PACKAGE
 * https://jira.jtiweb.co.uk/browse/DESP-79101
 */
export const prepareOrderAttributes = (orderAttributesValues, orderAttributesConfig) => {
    const orderAttributesMap = orderAttributesConfig.reduce((map, attribute) => {
        map[attribute.code] = attribute.placement;
        return map;
    }, {});
    const updatedShippingAttributes = [];
    const updatedBillingAttributes = [];
    for (const attribute of orderAttributesValues) {
        const placement = orderAttributesMap[attribute.attribute_code];
        if (placement === "shippingAddress_before" || placement === "shippingAddress_after") {
            updatedShippingAttributes.push(attribute);
        }
        else if (placement === "billingaddress_before" || placement === "billingaddress_after") {
            updatedBillingAttributes.push(attribute);
        }
    }
    return {
        updatedShippingAttributes,
        updatedBillingAttributes,
    };
};
//# sourceMappingURL=prepareOrderAttributes.js.map